export default function PrivacySection() {

  return (
<section className="pb-16 bg-white min-h-screen">
      <div className="max-w-6xl mx-auto px-8 sm:px-8 lg:px-0 mt-[30px]">

        <h1 className="text-4xl font-bold text-[#00889D] mb-6">
          Privacy Policy
        </h1>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          <strong>Yoga 7 – Hot Yoga & Fitness Studio</strong><br />
          Effective Date: December 20, 2025
        </p>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          Yoga Seven (“Yoga 7,” “we,” “us,” or “our”) is committed to protecting your personal information in accordance with the British Columbia Personal Information Protection Act (PIPA).
        </p>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          This Privacy Policy explains how we collect, use, disclose, and safeguard personal information when you visit www.yogaseven.com, use our booking and customer management systems (including Mariana Trek), or interact with us in person or online.
        </p>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          By using our services, you consent to the collection, use, and disclosure of your personal information as described below.
        </p>

        <h2 className="text-3xl font-bold text-[#00889D] mb-8">
          1. Personal Information We Collect
        </h2>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          We may collect the following categories of personal information:
        </p>

        <p className="text-base text-gray-600 mb-6 leading-relaxed font-semibold">
          a) Identifying & Contact Information
        </p>

        <ul className="text-base text-gray-600 mb-6 leading-relaxed list-disc pl-6">
          <li>Full name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Mailing address</li>
        </ul>

        <p className="text-base text-gray-600 mb-6 leading-relaxed font-semibold">
          b) Account, Booking & Transaction Information
        </p>

        <ul className="text-base text-gray-600 mb-6 leading-relaxed list-disc pl-6">
          <li>Account login details</li>
          <li>class bookings, attendance history</li>
          <li>Memberships and packages</li>
          <li>
            Payment information (processed securely by third-party providers such as Mariana Trek; we do not store full credit card details)
          </li>
        </ul>

        <p className="text-base text-gray-600 mb-6 leading-relaxed font-semibold">
          c) Health & Wellness Information (Voluntary)
        </p>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          Information you choose to provide, such as injuries, physical limitations, pregnancy notifications, or wellness preferences
        </p>

        <p className="text-base text-gray-600 mb-6 leading-relaxed font-semibold">
          d) Technical & Usage Information
        </p>

        <ul className="text-base text-gray-600 mb-6 leading-relaxed list-disc pl-6">
          <li>IP address</li>
          <li>Device and browser type</li>
          <li>Website usage data (cookies, analytics)</li>
        </ul>

        <p className="text-base text-gray-600 mb-6 leading-relaxed font-semibold">
          e) Other Information
        </p>

        <ul className="text-base text-gray-600 mb-6 leading-relaxed list-disc pl-6">
          <li>Emergency contact details</li>
          <li>Communications and inquiries submitted through forms or email</li>
        </ul>

        <h2 className="text-3xl font-bold text-[#00889D] mb-8">
          2. How We Collect Personal Information
        </h2>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          We collect personal information:
        </p>

        <ul className="text-base text-gray-600 mb-6 leading-relaxed list-disc pl-6">
          <li>
            Directly from you when you create an account, book classes, purchase services, complete forms, or contact us
          </li>
          <li>
            Through our service providers, including Mariana Trek, which manages bookings, memberships, and payments
          </li>
          <li>
            Automatically through cookies and similar technologies when you use our website
          </li>
        </ul>

        <h2 className="text-3xl font-bold text-[#00889D] mb-8">
          3. How We Use Personal Information
        </h2>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          We use personal information for purposes that a reasonable person would consider appropriate, including to:
        </p>

        <ul className="text-base text-gray-600 mb-6 leading-relaxed list-disc pl-6">
          <li>Provide and manage classes, memberships, and services</li>
          <li>Process payments and transactions</li>
          <li>Communicate schedules, updates, promotions, and newsletters</li>
          <li>Respond to inquiries and provide customer support</li>
          <li>Improve our services, website, and client experience</li>
          <li>Meet legal, regulatory, and insurance requirements</li>
        </ul>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          We do not sell your personal information.
        </p>

        <h2 className="text-3xl font-bold text-[#00889D] mb-8">
          4. Consent & Marketing Communications
        </h2>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          By providing your contact information, you consent to receive communications related to your account and services.
        </p>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          You may also receive marketing or promotional communications.
        </p>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          You may withdraw consent at any time by:
        </p>

        <ul className="text-base text-gray-600 mb-6 leading-relaxed list-disc pl-6">
          <li>Clicking “unsubscribe” in marketing emails, or</li>
          <li>Contacting us directly</li>
        </ul>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          Transactional or administrative messages (e.g., class confirmations) may still be sent.
        </p>

        <h2 className="text-3xl font-bold text-[#00889D] mb-8">
          5. Cookies & Analytics
        </h2>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          We use cookies and analytics tools to:
        </p>

        <ul className="text-base text-gray-600 mb-6 leading-relaxed list-disc pl-6">
          <li>Improve website functionality</li>
          <li>Understand user behaviour</li>
          <li>Measure marketing effectiveness</li>
        </ul>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          You can adjust cookie settings in your browser. Disabling cookies may affect site functionality.
        </p>

        <h2 className="text-3xl font-bold text-[#00889D] mb-8">
          6. Disclosure of Personal Information
        </h2>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          We may disclose personal information:
        </p>

        <ul className="text-base text-gray-600 mb-6 leading-relaxed list-disc pl-6">
          <li>To service providers who support our operations (e.g., Mariana Tek, payment processors, email platforms)</li>
          <li>When required by law or legal process</li>
          <li>To protect the rights, safety, or property of Yoga 7, our clients, or others</li>
          <li>With your consent</li>
        </ul>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          Service providers are required to protect personal information and use it only for authorized purposes.
        </p>

        <h2 className="text-3xl font-bold text-[#00889D] mb-8">
          7. Storage & International Access
        </h2>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          Your personal information may be stored or processed outside British Columbia or Canada (for example, on secure servers used by Mariana Trek or other cloud-based service providers).
        </p>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          Where information is transferred outside Canada, we take reasonable steps to ensure appropriate safeguards are in place, as required by BC PIPA.
        </p>

        <h2 className="text-3xl font-bold text-[#00889D] mb-8">
          8. Access, Correction & Retention
        </h2>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          You have the right to:
        </p>

        <ul className="text-base text-gray-600 mb-6 leading-relaxed list-disc pl-6">
          <li>Request access to your personal information</li>
          <li>Request corrections to inaccurate information</li>
          <li>Withdraw consent, subject to legal or contractual restrictions</li>
        </ul>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          Personal information is retained only as long as necessary to fulfil its purpose or meet legal requirements.
        </p>

        <h2 className="text-3xl font-bold text-[#00889D] mb-8">
          9. Security Safeguards
        </h2>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          We use reasonable administrative, technical, and physical safeguards to protect personal information against loss, theft, and unauthorized access. However, no system can be guaranteed to be completely secure.
        </p>

        <h2 className="text-3xl font-bold text-[#00889D] mb-8">
          10. Minors
        </h2>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          Our services are not intended for individuals under the age of 16 without parental or guardian consent. We do not knowingly collect personal information from minors without appropriate consent.
        </p>

        <h2 className="text-3xl font-bold text-[#00889D] mb-8">
          11. Changes to This Privacy Policy
        </h2>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          We may update this Privacy Policy from time to time. The most current version will be posted on our website with the updated effective date.
        </p>
        <h2 className="text-3xl font-bold text-[#00889D] mb-8">
          12. Contact Information
        </h2>

        <p className="text-base text-gray-600 mb-6 leading-relaxed">
          If you have questions about this Privacy Policy or wish to access or correct your personal information, please contact:
        </p>

        <h2 className="text-1xl font-bold text-[#00889D] mb-8">Yoga 7 – Hot Yoga & Fitness Studio</h2>
        <p> Langley, British Columbia, Canada<br />
          Email: info@yogaseven.com<br />
          Website: www.yogaseven.com
        </p>

      </div>

    </section>
  );
}
